// extracted by mini-css-extract-plugin
module.exports = {"container":"reasons_container__JO14z","reason":"reasons_reason__rjCuJ","containerIcon":"reasons_containerIcon__2r_GP","icon":"reasons_icon__170mB"};